export default {
  formFields: {
    fieldHelp: 'Click to open the description',
    defaultAbbreviation: 'df.: ',
    paramJSONContent: 'JSON content',
    wrongInputValue: 'Wrong input value for this parameter.',
    notValidJsonString: 'No valid Json for :fieldName',
  }
}
